import { sleep } from "../utils/common";
import html2PDF from "jspdf-html2canvas";
import { Options as Html2CanvasOptions } from "html2canvas";

/**
 * 等待预期的dom出现
 * @param selector
 * @param timeout
 */
export async function waitUntilLoaded(selector: string, timeout?: number) {
    return new Promise(async (resolve, reject) => {
        const controller = new AbortController();

        setTimeout(() => {
            controller.abort();
            reject("加载超时");
        }, timeout);

        while (!controller.signal.aborted) {
            if (document.querySelectorAll(selector).length !== 0) {
                resolve();
                break;
            }
            await sleep(1000);
        }
    });
}

/**
 * 对dom进行截图
 * @param selector
 * @param options
 */
export async function takeSnapshot(
    selector: string,
    options?: Partial<Html2CanvasOptions>
) {
    options = Object.assign(
        { useCORS: true, imageTimeout: 5 * 60 * 1000 },
        options
    );

    const wrapper: any = document.querySelector(selector);
    if (!wrapper) throw new Error("指定的内容不存在");

    const pdf = await html2PDF(wrapper, {
        html2canvas: options,
        success: () => {}
    });

    return pdf.output("blob");
}

/**
 * 获取dom里所有图片地址
 * @param selector
 */
export function getImagesFromSelector(selector: string) {
    const elements = document.querySelectorAll(`${selector} img`);

    return Array.from(elements).map(
        item => item.attributes.getNamedItem("src")?.value || ""
    );
}

/**
 * 获取dom里所有链接地址
 * @param selector
 */
export function getFilesFromSelector(selector: string) {
    const elements = document.querySelectorAll(`${selector} a`);

    return Array.from(elements).map(
        item => item.attributes.getNamedItem("href")?.value || ""
    );
}
